import { render, staticRenderFns } from "./CompanyDesktopMealEmployees.vue?vue&type=template&id=c6964dd2"
import script from "./CompanyDesktopMealEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopMealEmployees.vue?vue&type=script&lang=js"
import style0 from "./CompanyDesktopMealEmployees.vue?vue&type=style&index=0&id=c6964dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports